import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral } from '../../../../style/colors';

export const Section = styled.div`
  padding: 0;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${neutral[900]};
  margin-bottom: 24px;
  letter-spacing: -0.3px;
`;

export const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Link = styled.a`
  color: ${primary[500]};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 8px;
  background: ${primary[50]};
  border: 1px solid ${primary[200]};
  transition: all 0.2s ease;
  width: fit-content;

  i {
    font-size: 18px;
  }

  &:hover {
    background: ${primary[100]};
    border-color: ${primary[500]};
    transform: translateX(2px);
    box-shadow: 0 2px 8px ${rgba(primary[500], 0.15)};
  }
`;

export const VideoContainer = styled.div`
  margin-top: 20px;
`;

export const Video = styled.video`
  width: 100%;
  max-width: 640px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
`;
